module.exports = __webpack_public_path__ + "static/media/EditPhoto.598b0828.svg";